<div class="theme-toggle-container" [class.disabled]="!isOnCollectionRoute">
    <button class="theme-btn" [class.active]="isDark" (click)="setTheme('dark-theme')"
        [disabled]="!isOnCollectionRoute" aria-label="Switch to dark mode">
        Dark
    </button>
    <button class="theme-btn" [class.active]="isLight" (click)="setTheme('light-theme')"
        [disabled]="!isOnCollectionRoute" aria-label="Switch to light mode">
        Light
    </button>
</div>